import _ from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Tooltip from '@material-ui/core/Tooltip'
import Paper from '@material-ui/core/Paper'

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell)

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  tooltipTrigger: {
    borderBottom: '1px dotted #aaa',
    cursor: 'help'
  }
})

function CustomizedTable(props) {
  const data = [
    ['sat/B', 'satoshi per byte', props.fee || 'NaN', '100,000,000 satoshi = 1 BTC'],
    ['μBTC/B', 'μBTC per byte', (props.fee / 100).toFixed(2), '100 satoshi = 1 μBTC = 0.000001 BTC'],
    ['mBTC/B', 'mBTC per byte', (props.fee / 100000).toFixed(5), '100,000 satoshi = 1 mBTC = 0.001 BTC'],
    ['BTC/B', 'BTC per byte', (props.fee / 100000000).toFixed(8)],

    ['μBTC/kB', 'μBTC per kilobyte', (props.fee * 10).toFixed(0), '100 satoshi = 1 μBTC = 0.000001 BTC'],
    ['mBTC/kB', 'mBTC per kilobyte', (props.fee / 100).toFixed(2), '100,000 satoshi = 1 mBTC = 0.001 BTC'],
    ['BTC/kB', 'BTC per kilobyte', (props.fee / 100000).toFixed(5)]
  ]

  const { classes } = props

  return (
    <Paper className={classes.root}>
      <Table className={classes.table}>

        {/* <TableHead>
          <TableRow>
            <CustomTableCell>Fee calculation type</CustomTableCell>
            <CustomTableCell>Abbreviation</CustomTableCell>
            <CustomTableCell numeric>Fee</CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((n, idx) => {
            return (
              <TableRow className={classes.row} key={idx}>
                <CustomTableCell component="th" scope="row">{n[1]}</CustomTableCell>
                <CustomTableCell><b>{n[0]}</b></CustomTableCell>
                <CustomTableCell numeric>{n[2]}</CustomTableCell>
              </TableRow>
            )
          })}
        </TableBody> */}

        <TableHead>
          <TableRow>
            <CustomTableCell>Fee calculation type</CustomTableCell>
            <CustomTableCell numeric>Custom fee</CustomTableCell>
            <CustomTableCell>Abbr</CustomTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((n, idx) => {
            return (
              <TableRow className={classes.row} key={idx}>
                <CustomTableCell component="th" scope="row">
                  {
                    n[3] ? 
                    <Tooltip title={n[3]} placement="top">
                      <span className={classes.tooltipTrigger}>{_.first(_.split(n[1], ' '))}</span>
                    </Tooltip> :
                    _.first(_.split(n[1], ' '))
                  }
                  {' ' + _.join(_.tail(_.split(n[1], ' ')), ' ')}
                </CustomTableCell>
                <CustomTableCell numeric><b>{n[2]}</b></CustomTableCell>
                <CustomTableCell>{n[0]}</CustomTableCell>
              </TableRow>
            )
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell colSpan={3}>
              Different wallets have different ways to set up a custom transaction fee, so pick the one that applies to your wallet. All of these are the same, just the measure is different.
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </Paper>
  )
}

CustomizedTable.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(CustomizedTable)



// WEBPACK FOOTER //
// ./src/FeesTable.js